var _rect, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApp2FaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 44,
    viewBox: "0 0 33 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 44,
    fill: "url(#pattern0)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_26189_1144",
    transform: "translate(-0.166667) scale(0.0208333 0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_26189_1144",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAC6klEQVR4nO2bP08UQRjGfyHmmjs7oLqrLSRRC//EYKL2JEr4JHRGG0Ii2Ogh8iUMsfCQSitjqcaInXYcHclxXoEJcBbzbpbcuf/mZufdmPklk9mdfWffZ56bPXaWW5iMWWAV+AoMgKGnMgC+SO6ZCcdgzRLQTxDosxwBiyWPdYwl4EwEvAXuAnWP+evAPaAjGk7xaMIs8Sf/yFfSFB5jtPTwdDmsEn/yRfhEPG0/JrT/63geopmwUrAfU0U7AAtSPy/Yb5hjO60tjRdSL6RGOeI3RmDDR7KcXMRo6vtIFk3TqmGly+YS+K8IBmgL0CYYoC1Am2CAtgBtggEKOeeANrCHWdcPZLstxyqP7Z1gDdjCLF2T1vYnwKbE+tLlJVEN+CD9joEN4CZmXV+X7U3gj8S8p7gJlTZgS/rsA1dS4q5KzBB46UGXFUUTzWGm9jHx4FvANmb11gfeAJfk2DXMTDgBLpeoy5qiidoSvyH7LeCQ8ev/EGhKzCtpK/LMobIG/JD4G7K/LfvvMANuArvS9lpibsn+9xJ1WVM0UfT8sDGy3zwX0yJ+wgt2Dzgqa8BofFL/vHGudAHhTjAYEAwo4Zw14BlwQPo1PfpnMC2uC6xjd4vsnKwvm3XGB+eqrE2gyxlZibpy/LbDnPPEM8FWlzOyEpUlpJS84UtQW4A2wQBtAdoEA7QFaBMM0BagTTBAW4A2wYASznkg9bzDc96ROm0x5I2sRcca9svdrPJ0Al3OyEpUw5jQxd3A9zGDT3sgUhkDtAjLYRuCAdoCtAkGaAvQJhjg4By7wE5F2ryQ57+4Gm3hPsCGCw7O8Y1x57XavDD6i48pxmeS77boFyVHFMTmEvgl9XWpz6Scx3dbpOVnouoEbAzoSL1s0bcsIi2d1ChHzGCm2hDz0qI2TzBaesC0r6SLxL/57QD38fsaXUNy7oiGU+CBx/yAMaFHeU9/8pYe8LDksSYyjXld9TPxC5U+Sl9yrjDhtP8LKVXLlUrjLgoAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp2FaIcon);
export default __webpack_public_path__ + "static/media/app-2fa-icon.f5226e3b.svg";
export { ForwardRef as ReactComponent };